import i18n from '../../../../i18n'

export const columns = [
    {
        field: 'firstName',
        headerName: i18n.t('First name'),
        width: '15%',
    },
    {
        field: 'lastName',
        headerName: i18n.t('Last name'),
        width: '15%',
    },
    {
        field: 'email',
        headerName: i18n.t('Email'),
        width: '30%',
    },
    {
        field: 'phoneNumber',
        headerName: i18n.t('Phone number'),
        width: '25%',
    },
    {
        field: 'company',
        headerName: i18n.t('Company'),
        width: '15%',
    },
]
